export class SkyLinkRecordsSelectedSetSelectedAction {
  constructor(
    public key: string,
    public fieldKey: string,
    public selected: boolean
  ) {}
}
